'use client';
import Popup from 'reactjs-popup';
import * as Icon from '@/ui/Icon';
import { Row, Box, Stack } from '@/ui/primatives';

import Link from 'next/link';

type PopupPosition =
  | 'top left'
  | 'top center'
  | 'top right'
  | 'right top'
  | 'right center'
  | 'right bottom'
  | 'bottom left'
  | 'bottom center'
  | 'bottom right'
  | 'left top'
  | 'left center'
  | 'left bottom'
  | 'center center';

const KeyEditorToolTip: React.FC<{ popupPosition?: PopupPosition }> = ({ popupPosition = 'right center' }) => {
  return (
    <Popup
      trigger={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon.InfoCircle style={{ color: 'blue', background: 'AliceBlue', borderRadius: 8 }} />
        </div>
      }
      position={popupPosition}
      on={['hover']}
      arrow={true}
    >
      <div>
        <Box padding={10}>
          <Stack gap={5}>
            <Row gap={10}>
              <Icon.Key />
              <div>Select primary-join keys</div>
            </Row>
            <Row gap={10}>
              <Icon.ColumnCompare />
              <div>Select values to compare</div>
            </Row>
            <Link href="/" target="_blank" style={{ display: 'none' }}>
              dummy link to avoid autofocus ugly
            </Link>
            <Link
              className="link-underline"
              href="https://docs.oxen.ai/concepts/diffs"
              target="_blank"
              style={{ whiteSpace: 'nowrap' }}
            >
              Learn more about Data Diffs.
            </Link>
          </Stack>
        </Box>
      </div>
    </Popup>
  );
};

export default KeyEditorToolTip;
